<template>
  <TheGreyWrapper>
    <TheHeader class="md:mb-2" />
    <BaseSection class="mb-4">
      <BaseTitleGroup
        :title="$t('Connection')"
        subtitle="Plateforme Kerala"
      />
    </BaseSection>
    <BaseSection>
      <BaseWarningBox
        v-if="error"
        class="mb-4"
      >
        <span class="text-black font-heavy">{{ $t('Warning') }}: </span>
        {{ $t(`errors.${error}`) }}
      </BaseWarningBox>
      <form @submit.prevent="login()">
        <BaseInputGroup
          v-model="loginEmail"
          :label="$t('Email')"
          type="email"
          class="mb-4"
          autofocus
          required
        />
        <BaseInputGroup
          :label="$t('Password')"
          v-model="password"
          type="password"
          class="mb-4"
          required
        />
        <BaseButton
          :title="$t('Sign in')"
          class="mb-6"
        />
      </form>
      <BaseButton
        :title="$t('Forgot your password ?')"
        to="/password-forgotten"
        theme="secondary"
        class="mb-8"
      />
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import { mapState } from 'vuex';
import TheHeader from '../components/TheHeader.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseInputGroup from '../components/BaseInputGroup.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseWarningBox from '../components/BaseWarningBox.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';
import { STORE_LOGIN_EMAIL, LOGIN } from '../store/mutation-types';

export default {
  name: 'Login',
  metaInfo: {
    title: 'Connexion',
  },
  components: {
    TheHeader,
    BaseTitleGroup,
    BaseSection,
    BaseInputGroup,
    BaseButton,
    BaseWarningBox,
    TheGreyWrapper,
  },
  data() {
    return {
      password: '',
      error: this.$route.query.message,
    };
  },

  computed: {
    ...mapState('auth', ['user']),
    loginEmail: {
      set(value) {
        this.$store.commit(`auth/${STORE_LOGIN_EMAIL}`, value);
      },
      get() {
        return this.$store.state.auth.loginEmail;
      },
    },
  },

  updated() {
    this.checkCurrentLogin();
  },

  created() {
    this.checkCurrentLogin();
  },

  methods: {
    checkCurrentLogin() {
      if (localStorage.authorization && this.user) {
        this.$router.replace(this.$route.query.redirect || '/investments');
      }
    },

    login() {
      delete localStorage.authorization;
      this.$http.defaults.headers.Authorization = undefined;
      this.$store.dispatch('auth/login', this.password)
        .then(request => this.loginSuccessful(request))
        .catch(this.loginFailed);
      analytics.track('Logged in');
    },

    loginFailed(error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          if (
            data.error === 'Email ou mot de passe incorrect.' ||
            data.error === 'revoked token' ||
            data.error === 'Email ou mot de passe invalide.') {
            this.error = 'Unauthorized';
          } else if (data.error === "Votre compte n'est pas encore activé.") {
            this.error = 'Unactivated';
          }
        } else if (status === 422) {
          this.error = data.message;
        }
      } else {
        this.error = 'failedLogin';
      }
      delete localStorage.authorization;
    },

    loginSuccessful(req) {
      if (!req.headers.authorization) {
        this.loginFailed();
        return;
      }

      localStorage.authorization = req.headers.authorization;
      this.$http.defaults.headers.Authorization = req.headers.authorization;
      this.error = false;
      this.$store.commit(`auth/${LOGIN}`);

      this.$router.push(this.$route.query.redirect || '/investments');
    },
  },
};
</script>
